/**
 * Concatena classes condicionais. Substituto local de `classnames`/`clsx`
 * — não queremos uma nova dependência só para isso. Aceita strings,
 * `false`/`undefined`/`null` (filtrados) e nested arrays.
 */
export type ClassValue = string | false | undefined | null | ClassValue[];

export function cn(...values: ClassValue[]): string {
  const parts: string[] = [];
  for (const v of values) {
    if (!v) continue;
    if (Array.isArray(v)) {
      const inner = cn(...v);
      if (inner) parts.push(inner);
      continue;
    }
    parts.push(v);
  }
  return parts.join(' ');
}
